import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { iconsSlice } from "../app/pages/Gallery/_redux/IconsSlice";
import { lppsSlice } from "../app/pages/Lpp/_redux/lppsSlice";
import { dtpsSlice } from "../app/pages/Dtp/_redux/dtpsSlice";
import { standardSlice } from "../app/pages/Standard/_redux/slice";
import { workflowSlice } from "../app/pages/ApprovalFlow/_redux/slice";
import { userSlice } from '../app/pages/Users/_redux/slice';
import { structureSlice } from '../app/pages/Structure/_redux/slice';
import trainingSlice from '../app/pages/Training/_redux/slice';
import trainingBISlice from '../app/pages/TrainingnoBI/_redux/slice';
import filtersSlice from '../app/containers/filter/_redux/slice';
import idcardSlice from '../app/pages/Idcard/_redux/slice'
import trainingmaterialSlice from '../app/pages/TrainingMaterial/_redux/slice'
import lpptestSlice from '../app/pages/Lpp/_redux/slice'
import  dtptestSlice  from "../app/pages/Dtp/_redux/slice";
import FunnelSlice from '../app/pages/Funnel/_redux/slice';
import { slice } from './Standards/slice';


/**
 * @interface
 */
export const rootReducer = combineReducers({
  auth: auth.reducer,
  user: userSlice.reducer,
  structure: structureSlice.reducer,
  standardAdmin: standardSlice.reducer,
  standard: standardSlice.reducer,
  lpp: lppsSlice.reducer,
  dtp: dtpsSlice.reducer,
  idCard: slice('idCard').reducer,
  funil: slice('funil').reducer,
  trainingMaterial: slice('trainingMaterial').reducer,
  lpptest: slice('lpptest').reducer,
  iLearn: slice('iLearn').reducer,
  dms: slice('dms').reducer,
  plil: slice('plil').reducer,
  centerline: slice('centerline').reducer,
  qms: slice('qms').reducer,
  aspimp: slice('aspimp').reducer,
  lpd: slice('lpd').reducer,
  operacional: slice('operacional').reducer,
    formulario: slice('formulario').reducer,
    lv: slice('lv').reducer,
    gta: slice('gta').reducer,
    proc: slice('proc').reducer,
    spec: slice('spec').reducer,
    manual: slice('manual').reducer,
    sop: slice('sop').reducer,
    haccp: slice('haccp').reducer,
    metodologia: slice('metodologia').reducer,
    ksr: slice('ksr').reducer,
    ferramenta_fluxos: slice('Ferramenta & Fluxos').reducer,
    Indicadores: slice('Indicadores').reducer,
    Assessment: slice('Assessment').reducer,
    Coaching: slice('Coaching').reducer,
  icons: iconsSlice.reducer,
  workflow: workflowSlice.reducer,
  training: trainingSlice,
  trainingBI: trainingBISlice,
  filters: filtersSlice,
    idcard: idcardSlice,
    dtptest: dtptestSlice,
    trainingmaterial: trainingmaterialSlice,
    lpptest: lpptestSlice,
  funnel: FunnelSlice,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
